import { cn } from '@/lib/cn';

/**
 * Marca MANAXER — usa los PNG oficiales del manual de marca.
 * 'full'    → logo horizontal con wordmark + tagline (public/brand/logo-manaxer.png)
 * 'isotipo' → solo isotipo (3 barras + polilínea con nodos) (public/brand/isotipo-manaxer.png)
 */

interface BrandMarkProps {
  variant?: 'full' | 'isotipo';
  className?: string;
  /** Altura en px (width se ajusta por aspect ratio). */
  size?: number;
}

export function BrandMark({ variant = 'full', className, size = 36 }: BrandMarkProps) {
  const src =
    variant === 'isotipo' ? '/brand/isotipo-manaxer.png' : '/brand/logo-manaxer.png';

  return (
    <img
      src={src}
      alt="MANAXER — Tu gestión. Todo en orden."
      style={{ height: size }}
      className={cn('w-auto select-none', className)}
      draggable={false}
    />
  );
}
